import { FC, ReactElement } from "react";
import { Button, ButtonProps } from "@mui/material";

interface IContainedButton extends ButtonProps {
  title: string;
}

const ContainedButton: FC<IContainedButton> = ({
  title,
  variant,
  size,
  ...rest
}): ReactElement => {
  return (
    <Button
      {...rest}
      variant={variant ?? "contained"}
      fullWidth
      sx={{
        fontSize: size === "large" ? "16px" : "14px",
        fontWeight: size === "large" ? 500 : 400,
        boxShadow:
          variant === "text" || variant === "outlined"
            ? "none"
            : "0px 3px 8px 0px #1A1A1A26",
        border: variant === "text" ? "1px solid #E6E6E9" : "",
        ...rest.sx,
      }}
    >
      {title}
    </Button>
  );
};

export default ContainedButton;
